module.exports = __webpack_public_path__ + "img/pdf-file-icon.3147693d.svg";